import {i18n} from '../maps/i18nMap';

const __i18n__ = i18n;

export const _ = key => {
    return __i18n__['EN'] && __i18n__['EN'].map[key];
};
